module.exports = __webpack_public_path__ + "img/displacement-VARILUX-PHYSIO.32588291.png";